export enum FilesCategoryEnum {
  TERMO_TRANSFERENCIA = "TERMO_TRANSFERENCIA",
  TERMO_CESSAO = "TERMO_CESSAO",
  ENTUBA_UNIFICADA_CEDENTE_COTA = "ENTUBA_UNIFICADA_CEDENTE_COTA",
  ENTUBA_UNIFICADA_CEDENTE_COTA_PJ = "ENTUBA_UNIFICADA_CEDENTE_COTA_PJ",
  ENTUBA_APROVAÇAO_TRANSFERENCIA = "ENTUBA_APROVAÇAO_TRANSFERENCIA",
  ENTUBA_ATUALIZACAO_CEDENTE_PF = "ENTUBA_ATUALIZACAO_CEDENTE_PF",
  ENTUBA_ATUALIZACAO_CEDENTE_PJ = "ENTUBA_ATUALIZACAO_CEDENTE_PJ",
  ENTUBA_ATUALIZACAO_CESSIONARIO = "ENTUBA_ATUALIZACAO_CESSIONARIO",
  ENTUBA_REPASSE_TRADE = "ENTUBA_REPASSE_TRADE",
  OUTROS = "OUTROS",
  INSTRUMENTO_PUBLICO_CESSAO = "INSTRUMENTO_PUBLICO_CESSAO",
  INSTRUMENTO_PUBLICO_MANDATO = "INSTRUMENTO_PUBLICO_MANDATO",
  TERMO_CONDICOES_GERAIS = "TERMO_CONDICOES_GERAIS",
  TERMO_ACEITE = "TERMO_ACEITE",
  CAPA_DO_PROCESSO = "CAPA_DO_PROCESSO",
  SUBSTABELECIMENTO = "SUBSTABELECIMENTO",
  ENTUBA_EXPOSURE_VALUE = "ENTUBA_EXPOSURE_VALUE",
  PRINCING_BATCH = "PRINCING_BATCH",
  OFFICER_INSTRUCTIONS = "OFFICER_INSTRUCTIONS",
  BCHECK_BATCH = "BCHECK_BATCH",
  ENTUBA_PRINCING = "ENTUBA_PRINCING",
  ENTUBA_BCHECK = "ENTUBA_BCHECK",
  ENTUBA_COTA_PRICE = "ENTUBA_COTA_PRICE",
  ACQUITTANCE_TERM = "ACQUITTANCE_TERM",
  SOLICITATION_CREDIT_TERM = "SOLICITATION_CREDIT_TERM",
  ENTUBA_UPDATE_COTA_LOTE = "ENTUBA_UPDATE_COTA_LOTE",
  ENTUBA_RECEIVABLES = "ENTUBA_RECEIVABLES",
  ENTUBA_COTA_DEACTIVATION = "ENTUBA_COTA_DEACTIVATION",
  REPORT_LEADS = "REPORT_LEADS",
  ENTUBA_BP = "ENTUBA_BP",
  ENTUBA_BP_LEADS = "ENTUBA_BP_LEADS",
  ENTUBA_BP_FILES = "ENTUBA_BP_FILES",
  ENTUBA_FORMALIZATION_EXTRACT_PF = "ENTUBA_FORMALIZATION_EXTRACT_PF",
  ENTUBA_FORMALIZATION_EXTRACT_PJ = "ENTUBA_FORMALIZATION_EXTRACT_PJ",
  ENTUBA_UPDATE_EXPENSE = "ENTUBA_UPDATE_EXPENSE",
  ENTUBA_UPDATE_QUOTA_POST_PURCHASE_PAGE = "ENTUBA_UPDATE_QUOTA_POST_PURCHASE_PAGE",
  ENTUBA_UPDATE_TRADE_PRICING = "ENTUBA_UPDATE_TRADE_PRICING"
}

export const FilesCategoryEnumLabel = new Map<FilesCategoryEnum, string>([
  [FilesCategoryEnum.TERMO_TRANSFERENCIA, "Termo de Transferência"],
  [FilesCategoryEnum.TERMO_CESSAO, "Termo de cessão"],
  [FilesCategoryEnum.TERMO_CONDICOES_GERAIS, "Termos e condições gerais"],
  [FilesCategoryEnum.TERMO_ACEITE, "Termo de aceite"],
  [FilesCategoryEnum.ENTUBA_UNIFICADA_CEDENTE_COTA, "Modelo Entuba Unificada - PF"],
  [FilesCategoryEnum.ENTUBA_UNIFICADA_CEDENTE_COTA_PJ, "Modelo Entuba Unificada - PJ"],
  [FilesCategoryEnum.ENTUBA_APROVAÇAO_TRANSFERENCIA, "Modelo Entuba aprovação transferência"],
  [FilesCategoryEnum.ENTUBA_ATUALIZACAO_CEDENTE_PJ, "Modelo Entuba Atualização Cedente PJ"],
  [FilesCategoryEnum.ENTUBA_ATUALIZACAO_CEDENTE_PF, "Modelo Entuba Atualização Cedente PF"],
  [FilesCategoryEnum.ENTUBA_ATUALIZACAO_CESSIONARIO, "Modelo Entuba Atualização Cessionário"],
  [FilesCategoryEnum.ENTUBA_REPASSE_TRADE, "Modelo Entuba Repasse de Trade"],
  [FilesCategoryEnum.OUTROS, "Outros"],
  [FilesCategoryEnum.CAPA_DO_PROCESSO, "Capa do processo"],
  [FilesCategoryEnum.SUBSTABELECIMENTO, "Substabelecimento"],
  [FilesCategoryEnum.ENTUBA_EXPOSURE_VALUE, "Modelo de Entuba de Valor de Exposição"],
  [FilesCategoryEnum.PRINCING_BATCH, "Modelo de Precificação em Lote"],
  [FilesCategoryEnum.BCHECK_BATCH, "Modelo de BCheck em Lote"],
  [FilesCategoryEnum.OFFICER_INSTRUCTIONS, "Manual de Instruções para Officer"],
  [FilesCategoryEnum.ENTUBA_PRINCING, "Modelo de Entuba de Precificação"],
  [FilesCategoryEnum.ENTUBA_BCHECK, "Modelo de Entuba BCheck"],
  [FilesCategoryEnum.INSTRUMENTO_PUBLICO_CESSAO, "Instrumento publico de cessão"],
  [FilesCategoryEnum.ENTUBA_COTA_PRICE, "Modelo Entuba cota price"],
  [FilesCategoryEnum.ACQUITTANCE_TERM, "Modelo de Carta de Quitação"],
  [FilesCategoryEnum.SOLICITATION_CREDIT_TERM, "Modelo de solicitação de crédito"],
  [FilesCategoryEnum.ENTUBA_UPDATE_COTA_LOTE, "Modelo de atualização cota em lote"],
  [FilesCategoryEnum.ENTUBA_RECEIVABLES, "Modelo de Atualização de Recebíveis"],
  [FilesCategoryEnum.ENTUBA_COTA_DEACTIVATION, "Modelo de desativação de cotas"],
  [FilesCategoryEnum.REPORT_LEADS, "Modelo de Report de Leads"],
  [FilesCategoryEnum.ENTUBA_BP, "Modelo de Entuba Business Partner"],
  [FilesCategoryEnum.ENTUBA_BP_LEADS, "Modelo de Entuba Business Partner Leads"],
  [FilesCategoryEnum.ENTUBA_BP_FILES, "Modelo de Entuba Business Partner com arquivo"],
  [FilesCategoryEnum.ENTUBA_FORMALIZATION_EXTRACT_PF, "Modelo de Entuba de formalização por extrato PF"],
  [FilesCategoryEnum.ENTUBA_FORMALIZATION_EXTRACT_PJ, "Modelo de Entuba de formalização por extrato PJ"],
  [FilesCategoryEnum.ENTUBA_UPDATE_EXPENSE, "Modelo de Entuba de atualização de despesas"],
  [FilesCategoryEnum.ENTUBA_UPDATE_QUOTA_POST_PURCHASE_PAGE, "Modelo de entuba de atualização de pagamentos da cota"],
  [FilesCategoryEnum.ENTUBA_UPDATE_TRADE_PRICING, "Modelo de atualização de preço do trade"]
]);



// WEBPACK FOOTER //
// ./src/services/enum/FilesCategoryEnum.ts